import styled from '@emotion/styled';

const Svg = styled.svg`
  vertical-align: bottom;
`;

export { Svg };
